var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VTable',{attrs:{"items":_vm.items,"headers":_vm.headers,"total":_vm.total,"deleteable":_vm.$can(_vm.$permissions.CONSTRAIN_DELETE)},on:{"edit":_vm.edit,"delete":function($event){return _vm.$emit('delete', $event)},"page":function($event){return _vm.$emit('page', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }